import { useParams } from "react-router";
import type { Performance, PerformanceKind } from "../api/types";
import { useServices } from "../app/services";
import { useResource } from "../app/useResource";
import { PerformanceCard } from "../components/cards";
import { EmptyState, PageHeader, ResourceView } from "../components/ui";
import { kindLabel } from "../lib/labels";

const ORDER: PerformanceKind[] = ["original", "cover", "live", "stream"];

/** 曲ページ：一つの曲に属する歌唱（原曲・カバー・ライブ・歌枠）を種別ごとに */
export function WorkPage() {
  const { id = "" } = useParams();
  const { api } = useServices();
  const res = useResource("works.get", () => api.getWork(id), [id], ["library"]);
  return (
    <div className="page">
      <ResourceView resource={res} what="曲" rows={4}>
        {({ work, performances }) => {
          const groups = ORDER.map((k) => ({ kind: k, items: performances.filter((p) => p.kind === k) })).filter((g) => g.items.length > 0);
          return (
            <>
              <PageHeader
                title={work.title}
                lead={(work.aliases ?? []).length > 0 ? `別名：${(work.aliases ?? []).join("・")}` : `${performances.length}つの歌唱`}
              />
              {groups.length === 0 ? (
                <EmptyState title="この曲の歌唱はまだ登録されていません" icon="plus">
                  Discordで聴きながら「ここ好き」から歌唱を残せます。
                </EmptyState>
              ) : (
                groups.map((g) => <KindSection key={g.kind} kind={g.kind} items={g.items} />)
              )}
            </>
          );
        }}
      </ResourceView>
    </div>
  );
}

function KindSection({ kind, items }: { kind: PerformanceKind; items: Performance[] }) {
  return (
    <section className="section" aria-labelledby={`sec-${kind}`}>
      <h2 id={`sec-${kind}`} className="section-title">
        {kindLabel(kind)} <span className="count">{items.length}</span>
      </h2>
      <ul className="perf-list" data-reveal="stagger">
        {items.map((p) => (
          <PerformanceCard key={p.id} performance={p} />
        ))}
      </ul>
    </section>
  );
}
